"use client";

import { trackEventWithAttribution } from "@/lib/analytics/posthog-helpers";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { usePostHog } from "posthog-js/react";

export function InfluencerPracticeLink({
  placement,
  compact = false,
  className = "",
}: {
  placement: "header" | "hero" | "final";
  compact?: boolean;
  className?: string;
}) {
  const posthog = usePostHog();
  return (
    <Link
      href="/impromptu"
      onClick={() =>
        trackEventWithAttribution(posthog, "influencer_practice_cta_clicked", {
          placement,
          destination: "/impromptu",
        })
      }
      className={`inline-flex min-h-12 items-center justify-center gap-3 rounded-xl bg-[#FD954F] ${compact ? "px-4 text-sm" : "px-7 py-4 text-base"} font-bold text-[#1C1C1E] transition-colors hover:bg-[#F28747] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#A8431F] ${className}`}
    >
      {compact ? "Try Impromptu" : "Try my first topic"}
      <ArrowRight className="h-4 w-4 shrink-0" aria-hidden="true" />
    </Link>
  );
}
